import BasicContentHighlights from './BasicContentHighlights';

export { type BasicContentHighlightsProps } from './BasicContentHighlights';
export default BasicContentHighlights;
